import { z } from 'zod';

export const loginSchema = z.object({
  username: z.string().trim().min(1, 'required').max(100, 'tooLong'),
  password: z.string().min(1, 'required').max(200, 'tooLong'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
